import { ChangeDetectionStrategy, Component, computed, input, output, type InputSignal, type OutputEmitterRef, type Signal } from '@angular/core';
import { UiAvatarComponent } from '@nexus/frontend-shared-ui';
import type { WishlistNearestOccasionView } from '../../types/wishlist-nearest-occasion-view.interface';

@Component({
  selector: 'wishlist-nearest-occasion',
  imports: [UiAvatarComponent],
  templateUrl: './wishlist-nearest-occasion.component.html',
  styleUrl: './wishlist-nearest-occasion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistNearestOccasionComponent {
  public readonly view: InputSignal<WishlistNearestOccasionView | null> =
    input<WishlistNearestOccasionView | null>(null);
  public readonly selected: OutputEmitterRef<string> = output<string>();

  protected readonly hasPending: Signal<boolean> = computed((): boolean => this.view()?.pendingLabel != null);
  protected readonly beneficiaryInitials: Signal<string> = computed((): string => {
    const label: string = this.view()?.beneficiaryLabel.replace('Dla:', '').trim() ?? '';
    return label.charAt(0).toUpperCase() || 'W';
  });
  protected readonly progressPercent: Signal<number> = computed((): number => {
    const occasion: WishlistNearestOccasionView | null = this.view();
    return occasion?.itemsCount ? Math.min(100, Math.round(occasion.reservedCount / occasion.itemsCount * 100)) : 0;
  });

  protected handleSelected(): void {
    const occasion: WishlistNearestOccasionView | null = this.view();
    if (occasion) this.selected.emit(occasion.id);
  }
}
